import React, {useEffect, useState} from "react";
import {
    Container,
    Dropdown,
    Button,
    Form,
    Header, List
} from "semantic-ui-react";
import {RootState} from "../model";
import {connect} from "react-redux";
import Template from "./Template";
import {useActions} from "../redux/actions";
import * as practiceActions from "../redux/actions/practice";
import * as openDentalActions from "../redux/actions/openDental";

function UpdateBulkProviders() {
    const initialState: any = {
        practiceOpts: []
    };
    const initialForm: any = {
        provNums: [],
        practice: null
    }
    const [state, setState] = useState(initialState);
    const [form, setFormData] = useState(initialForm);
    const [responseText, setResponseText] = useState<any>("");
    const [providerList, setProviderList] = useState<any>([]);

    const practiceAction = useActions(practiceActions);
    const openDentalAction = useActions(openDentalActions);

    useEffect(() => {
        setTimeout(() => {
            const practiceOpts: any = [];
            practiceAction.getAllPractices().then((practices: any) => {
                practices && practices.forEach((item: any) => {
                    const practice = item.practice;
                    practiceOpts.push({
                        key: practice.id,
                        value: practice.practiceDBName,
                        text: practice.practice
                    })
                })
            })
            setState({
                ...state,
                practiceOpts: practiceOpts
            })
        }, 500);
    }, []);


    const submitHandler = () => {
        if (!form || !form.provNums.length || !form.practice) {
            alert("Please fill all required fields.");
            return;
        }
        if(window.confirm("Are you sure you want to hide selected providers?")){
            openDentalAction.updateBulkProviders(form)
                .then((res: any) => {
                    setResponseText(res);
                    setFormData(initialForm);
                    setProviderList([]);
                    alert('Bulk providers updated successfully.');
                }).catch((err: any) => {
                setResponseText(err);
            });
        }
    }

    const getProviders = (practice: string) => {
        setFormData({...form, practice: practice})
        openDentalAction.getProvidersByPractice(practice)
            .then((res: any) => {
                const providers: any = [];
                res && res.forEach((item: any) => {
                    providers.push({
                        key : item.UserNum,
                        value : item.ProvNum,
                        text : item.FName + ' ' + item.LName + ' (' + item.ProvNum + ')'
                    })
                })
                setProviderList(providers)
            }).catch((err: any) => {
            setProviderList([])
        })
    }
    return (
        <Template activeLink="update-bulk-providers">
            <Container>
                <Header as="h2">
                    <Header.Content>Update Bulk Providers</Header.Content>
                </Header>
                <Form className="mb20">
                    <Form.Field>
                        <label>Practices <span className={'red'}>*</span> </label>
                        <Dropdown
                            fluid={true}
                            selection={true}
                            options={state.practiceOpts}
                            onChange={(_, data) => {
                                getProviders(data.value as string)
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Providers <span className={'red'}>*</span> </label>
                        <Dropdown
                            fluid={true}
                            selection={true}
                            search={true}
                            multiple={true}
                            options={providerList}
                            onChange={(_, data) => {
                                setFormData({...form, provNums: data.value})
                            }}
                        />
                    </Form.Field>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>&nbsp;</label>
                            <Button
                                primary={true}
                                fluid={true}
                                onClick={() => submitHandler()}
                            >
                                Proceed
                            </Button>
                        </Form.Field>

                    </Form.Group>

                </Form>
                {responseText &&
                    <div className="ui card" style={{maxHeight: '350px', overflowY: 'auto'}}>
                        <div className="content">
                            <Header as="h4">Response</Header>
                            <pre>
                          {JSON.stringify(responseText, null, 2)}
                        </pre>
                        </div>
                    </div>
                }
            </Container>
        </Template>
    );
}

function mapStateToProps(state: RootState) {
    return {
        auth: state.auth,
        allPracticeList: state.practice.allPracticeList,
        loader: state.app.loader,
    };
}

export default connect(mapStateToProps)(UpdateBulkProviders);
